import { AnnouncementMessages, TranslationAnnouncementMessages } from "../interfaces/announcementMessages";

// eslint-disable-next-line import/prefer-default-export
export const messages: TranslationAnnouncementMessages = {
  [AnnouncementMessages.menuTitle]: "Notificaciones",
  [AnnouncementMessages.bellTooltip]: "Notificaciones",
  [AnnouncementMessages.dropdownTitle]: "NOTIFICACIONES",
  [AnnouncementMessages.markAllRead]: "Marcar todas como leídas",
  [AnnouncementMessages.viewAll]: "Ver todas las notificaciones",
  [AnnouncementMessages.emptyTitle]: "Ninguna notificación por aquí",
  [AnnouncementMessages.emptySubtitle]: "Las notificaciones y novedades aparecen aquí.",
  [AnnouncementMessages.defaultCta]: "Haz clic aquí",
  [AnnouncementMessages.bannerHighlight]: "DESTACADO",
  [AnnouncementMessages.bannerDismiss]: "Cerrar",
  [AnnouncementMessages.pageTitle]: "Notificaciones",
  [AnnouncementMessages.pageSubtitle]: "Notificaciones mostradas en la campana a todos los usuarios, dentro del período definido.",
  [AnnouncementMessages.newButton]: "Nueva notificación",
  [AnnouncementMessages.manageAccess]: "Gestionar acceso",
  [AnnouncementMessages.searchPlaceholder]: "Buscar por título",
  [AnnouncementMessages.loadError]: "Error al cargar las notificaciones, inténtelo de nuevo.",
  [AnnouncementMessages.retry]: "Intentar de nuevo",
  [AnnouncementMessages.listEmpty]: "Ninguna notificación registrada todavía.",
  [AnnouncementMessages.listTruncated]: "Mostrando {{shown}} de {{total}} notificaciones.",
  [AnnouncementMessages.tableTitle]: "Título",
  [AnnouncementMessages.tablePeriod]: "Período",
  [AnnouncementMessages.tableStatus]: "Estado",
  [AnnouncementMessages.tableReads]: "Lecturas",
  [AnnouncementMessages.tableClicks]: "Clics",
  [AnnouncementMessages.tableActions]: "Acciones",
  [AnnouncementMessages.statusActive]: "Activa",
  [AnnouncementMessages.statusScheduled]: "Programada",
  [AnnouncementMessages.statusExpired]: "Expirada",
  [AnnouncementMessages.byAuthor]: "por {{name}}",
  [AnnouncementMessages.reachEveryone]: "Todos los clientes",
  [AnnouncementMessages.reachTenantOne]: "1 cliente",
  [AnnouncementMessages.reachTenantMany]: "{{count}} clientes",
  [AnnouncementMessages.reachUserOne]: "1 persona",
  [AnnouncementMessages.reachUserMany]: "{{count}} personas",
  [AnnouncementMessages.clicksHint]: "Los números de lecturas y de clics abren la lista de quién recibió la notificación.",
  [AnnouncementMessages.formTitleNew]: "Nueva notificación",
  [AnnouncementMessages.formTitleEdit]: "Editar notificación",
  [AnnouncementMessages.formSubtitle]: "Visible a todos los usuarios dentro del período definido.",
  [AnnouncementMessages.fieldTitle]: "Título",
  [AnnouncementMessages.fieldMessage]: "Mensaje",
  [AnnouncementMessages.fieldLink]: "Enlace",
  [AnnouncementMessages.fieldLinkLabel]: "Texto del botón",
  [AnnouncementMessages.fieldStartDate]: "Inicio",
  [AnnouncementMessages.fieldEndDate]: "Fin",
  [AnnouncementMessages.fieldHighlight]: "Destacar en el Launcher (banner)",
  [AnnouncementMessages.fieldAudience]: "Quién lo recibe",
  [AnnouncementMessages.audienceEveryone]: "Todos los clientes",
  [AnnouncementMessages.audienceTargeted]: "Elegir quién lo recibe",
  [AnnouncementMessages.audienceEveryoneHint]: "Todos en la suite lo ven, en todos los clientes.",
  [AnnouncementMessages.audienceTargetedHint]: "Solo los clientes y las personas que elijas abajo.",
  [AnnouncementMessages.audienceSummaryLabel]: "Va para",
  [AnnouncementMessages.audienceSummaryEmpty]: "Elige al menos un cliente o una persona.",
  [AnnouncementMessages.targetTenantsHint]: "Todas las personas de esos clientes lo reciben.",
  [AnnouncementMessages.fieldTargetTenants]: "Clientes",
  [AnnouncementMessages.fieldTargetUsers]: "Personas",
  [AnnouncementMessages.targetUsersHint]: "Busque por nombre o correo. La persona lo recibe aunque su cliente no esté en la lista.",
  [AnnouncementMessages.audienceRequired]: "Seleccione al menos un cliente o una persona",
  [AnnouncementMessages.recipientSearching]: "Buscando...",
  [AnnouncementMessages.recipientNoResults]: "No se encontró a nadie",
  [AnnouncementMessages.linkHelper]: "Opcionales — con enlace, el botón usa este texto (predeterminado: \"Haz clic aquí\")",
  [AnnouncementMessages.endAfterStart]: "El fin debe ser posterior al inicio",
  [AnnouncementMessages.confirmDeleteTitle]: "Eliminar notificación",
  [AnnouncementMessages.confirmDeleteMessage]: "La notificación desaparece de la campana y del banner de todos los usuarios. ¿Continuar?",
  [AnnouncementMessages.interactionsTitle]: "Interacciones de la notificación",
  [AnnouncementMessages.interactionsEmpty]: "Ninguna interacción registrada todavía.",
  [AnnouncementMessages.interactionsUser]: "Usuario",
  [AnnouncementMessages.interactionsTenant]: "Inquilino",
  [AnnouncementMessages.interactionsReadAt]: "Leída el",
  [AnnouncementMessages.interactionsClickedAt]: "Clic el",
  [AnnouncementMessages.interactionsEmail]: "Correo",
  [AnnouncementMessages.interactionsCount]: "Total: {{count}}",
  [AnnouncementMessages.interactionsExport]: "Exportar CSV",
  [AnnouncementMessages.interactionsExportPartial]: "Exportadas {{exported}} de {{total}} filas. El archivo está incompleto.",
  [AnnouncementMessages.interactionsExporting]: "Exportando...",
  [AnnouncementMessages.managersTitle]: "Gestionar acceso",
  [AnnouncementMessages.managersSubtitle]: "Admins que pueden crear y gestionar notificaciones.",
  [AnnouncementMessages.managersEmpty]: "Ningún usuario con acceso todavía.",
  [AnnouncementMessages.managersGrantLabel]: "Conceder acceso a un admin",
  [AnnouncementMessages.managersGrantButton]: "Conceder",
  [AnnouncementMessages.managersRevoke]: "Revocar acceso",
  [AnnouncementMessages.managersGrantedBy]: "concedida por {{name}}"
};
